<template>
  <div class="strategy-text-5-section">
    <text-content-wrapper>
      <template v-slot:col-1>
        <div class="lead-1">{{ fields.field_one.value.text }}</div>
        <div class="line-separator"></div>
      </template>
      <template v-slot:col-2>
        <div class="paragraph-1">{{ fields.field_two.value.text }}</div>
        <ul>
          <li v-for="box in fields.field_two.value.boxes">{{ box.name }}</li>
        </ul>
      </template>
    </text-content-wrapper>
  </div>
</template>

<script>
import TextContentWrapper from "/seu-frontend/sections/general/TextContentWrapper";

export default {
  name: "StrategyText5Section",
  components: {TextContentWrapper},
  props: {
    fields: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
@import "StrategyText5Section.scss";
</style>
